define(["./nlgPasswordModule", "text!./nlgPassword.html"], function (nlgPasswordModule, template) {
    "use strict";

    return nlgPasswordModule.directive("nlgPassword", [function () {
        return {
            restrict: "E",
            scope: {
                password: "=",
                validate: "<?",
                placeholder: "@",
                name: "@",
                id: "@",
                cy: "@",
                enableAutoComplete: "<?",
            },
            template: template,
            controller: ["$scope", function ($scope) {
                $scope.password = "";
                $scope.isHidePassword = true;

                $scope.showHidePassword = function () {
                    $scope.isHidePassword = !$scope.isHidePassword;
                };

                $scope.getInputType = function () {
                    if (!$scope.isHidePassword) {
                        return "text";
                    }
                    return "password";
                };

                $scope.getEyeClass = function () {
                    if (!$scope.isHidePassword) {
                        return "fa fa-eye";
                    }
                    return "fa fa-eye-slash";
                };
            }]
        };
    }]);
});